// import ApiService from '@/helpers/api.service';
// const API = new ApiService();
import ApiServiceV6 from '@/helpers/api.service.v6gbits';
const API2 = new ApiServiceV6();
const ELOAD_B2B_ENDPOINT = "/topup-approval";
const S3_FOLDER = "deposit";

export const state = {
  eloadB2BRequests: [],
  eloadB2BRequestsTotal: 0,
  eloadB2BRequestDetails: {},
  eloadB2BUsers: [],
  eloadB2BBanks: [],
  eloadB2BPeddlrBanks: [],
  eloadB2BDefaultRebate: 0,
  eloadB2BBusinessNames: [],
  errors: null,
};

export const mutations = {
  UPDATE_ELOAD_B2B_REQUESTS(state, value) {
    state.eloadB2BRequests = value;
  },
  UPDATE_ELOAD_B2B_REQUESTS_TOTAL(state, total) {
    state.eloadB2BRequestsTotal = total;
  },
  UPDATE_ELOAD_B2B_REQUEST_DETAILS(state, value) {
    state.eloadB2BRequestDetails = value;
  },
  UPDATE_ELOAD_B2B_USERS(state, value) {
    state.eloadB2BUsers = value;
  },
  UPDATE_ELOAD_B2B_REBATE(state, value) {
    state.eloadB2BDefaultRebate = value;
  },
  UPDATE_ELOAD_B2B_BANKS(state, value) {
    state.eloadB2BBanks = value;
  },
  UPDATE_ELOAD_B2B_PEDDLR_BANKS(state, value) {
    state.eloadB2BPeddlrBanks = value;
  },
  UPDATE_ELOAD_B2B_BUSINESS_NAMES(state, value) {
    state.eloadB2BBusinessNames = value;
  },
  SET_PROD_ERRORS(state, errors) {
    state.errors = errors;
  },
};

export const actions = {
  getEloadB2BRequests(context, params) {
    return new Promise((resolve, reject) => {
      API2.post(`${ELOAD_B2B_ENDPOINT}/b2b-requests`, params)
        .then(({ data }) => {
          context.commit("UPDATE_ELOAD_B2B_REQUESTS", data.message.rows);
          context.commit("UPDATE_ELOAD_B2B_REQUESTS_TOTAL", data.message.pageInfo.total);
          resolve();
        })
        .catch((err) => {
          context.commit("SET_PROD_ERRORS", err?.response?.data?.message || err.message);
          reject();
        });
    });
  },
  getEloadB2BRequestDetails(context, params) {
    return new Promise((resolve, reject) => {
      API2.post(`${ELOAD_B2B_ENDPOINT}/b2b-request-details`, params)
        .then(({ data }) => {
          context.commit("UPDATE_ELOAD_B2B_REQUEST_DETAILS", data.message.request);
          resolve();
        })
        .catch((err) => {
          context.commit("SET_PROD_ERRORS", err?.response?.data?.message || err.message);
          reject();
        });
    });
  },
  async saveEloadB2BRequest(context, params) {
    return new Promise((resolve, reject) => {
      API2.post(`${ELOAD_B2B_ENDPOINT}/b2b-save-request`, params)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((err) => {
          context.commit("SET_PROD_ERRORS", err?.response?.data?.message || err.message);
          reject(err);
        });
    });
  },
  async getEloadB2BUsers(context, params) {
    return new Promise((resolve, reject) => {
      API2.post(`${ELOAD_B2B_ENDPOINT}/b2b-users`, params)
        .then(({ data }) => {
          context.commit("UPDATE_ELOAD_B2B_USERS", data.message.rows);
          context.commit("UPDATE_ELOAD_B2B_REBATE", data.message.defaultRebate);
          resolve();
        })
        .catch((err) => {
          context.commit("SET_PROD_ERRORS", err?.response?.data?.message || err.message);
          reject();
        });
    });
  },
  getEloadB2BBanks(context, params) {
    return new Promise((resolve, reject) => {
      API2.post(`${ELOAD_B2B_ENDPOINT}/b2b-banks`, params)
        .then(({ data }) => {
          context.commit("UPDATE_ELOAD_B2B_BANKS", data.message.rows.senderBanks);
          context.commit("UPDATE_ELOAD_B2B_PEDDLR_BANKS", data.message.rows.peddlrBanks);
          resolve();
        })
        .catch((err) => {
          context.commit("SET_PROD_ERRORS", err?.response?.data?.message || err.message);
          reject();
        });
    });
  },
  async uploadEloadB2BDepositImg(context, params){
    return new Promise((resolve, reject) => {
      var allowedType = ["jpg","jpeg","png"];
      if(params.type && !allowedType.includes(params.type.toLowerCase())){
        reject("Filetype not allowed");
        return;
      }

      const s3Key = params.accountId
        ? `${S3_FOLDER}/${params.accountId}/${params.filename}`
        : `${S3_FOLDER}/${params.filename}`;

      const contentType = (params.type == 'jpg' || params.type == 'jpeg') ? 'image/jpeg' : 'image/png';

      // Get presigned URL from backend
      API2.post(`${ELOAD_B2B_ENDPOINT}/b2b-upload-url`, { key: s3Key, contentType })
        .then(({ data }) => {
          const presignedUrl = data.message.presignedUrl;
          // Upload directly to S3 using presigned URL
          return fetch(presignedUrl, {
            method: 'PUT',
            headers: { 'Content-Type': contentType },
            body: params.base64
          }).then(res => {
            if (res.ok) {
              resolve(s3Key);
            } else {
              reject("Upload failed: " + res.statusText);
            }
          });
        })
        .catch(err => {
          console.log("Upload error:", err);
          reject(err?.response?.data?.message || err.message || "Upload failed");
        });
    });
  },
  postApprovedRequest(context, params) {
    return new Promise((resolve, reject) => {
      API2.post(`${ELOAD_B2B_ENDPOINT}/b2b-request-approved`, params)
        .then(({ data }) => {
          if(data?.status == "ok"){
            resolve(data);
          }else{
            reject(data);
          }
        })
        .catch((err) => {
          context.commit("SET_PROD_ERRORS", err?.response?.data?.message || err.message);
          reject();
        });
    });
  },
  postRejectedRequest(context, params) {
    return new Promise((resolve, reject) => {
      API2.post(`${ELOAD_B2B_ENDPOINT}/b2b-request-rejected`, params)
        .then(({ data }) => {
          if(data?.status == "ok"){
            resolve(data);
          }else{
            reject(data);
          }
        })
        .catch((err) => {
          context.commit("SET_PROD_ERRORS", err?.response?.data?.message || err.message);
          reject();
        });
    });
  },
  exportTopupRequests(context, params) {
    return new Promise((resolve, reject) => {
      API2.post(`${ELOAD_B2B_ENDPOINT}/b2b-export`, params)
        .then(({ data }) => {
          if (data?.status == "ok") {
            resolve(data);
          } else {
            reject(data);
          }
        })
        .catch((err) => {
          context.commit("SET_PROD_ERRORS", err?.response?.data?.message || err.message);
          reject(err);
        });
    });
  },
  clearRequestDetails(context){
    context.commit("UPDATE_ELOAD_B2B_REQUEST_DETAILS", {});
  },
  getTopupAccess() {
    return new Promise((resolve, reject) => {
      API2.post(`${ELOAD_B2B_ENDPOINT}/b2b-topup-access`, {})
        .then(({ data }) => {
          if (data?.status == "ok") {
            resolve(data.message);
          } else {
            reject(data);
          }
        })
        .catch((err) => {
          console.log("getTopupAccess error:", err);
          resolve({ create: false, read: false, update: false, delete: false });
        });
    });
  },
  getBusinessNames(context) {
    return new Promise((resolve, reject) => {
      API2.post(`${ELOAD_B2B_ENDPOINT}/b2b-business-names`, {})
        .then(({ data }) => {
          if (data?.status == "ok") {
            context.commit("UPDATE_ELOAD_B2B_BUSINESS_NAMES", data.message.rows);
            resolve(data.message.rows);
          } else {
            reject(data);
          }
        })
        .catch((err) => {
          console.log("getBusinessNames error:", err);
          resolve([]);
        });
    });
  }
};
